import { css } from '@emotion/react';
import { Lock } from '@phosphor-icons/react';

export const RepositoryTitle = ({ name, isPrivate }: { name: string; isPrivate: boolean }) => (
  <span css={repositoryTitleStyle}>
    {isPrivate && <Lock weight="fill" />} {name}
  </span>
);

const repositoryTitleStyle = css`
  display: flex;
  align-items: center;

  svg {
    margin-right: 0.5ch;
    opacity: 0.8;
  }
`;
